import {TypeButton} from "../../../components/TypeButton/TypeButton";
import {useState} from "react";
import Signature from "../Elements/Draggable/Input/Signature";
import Radio from "../Elements/Draggable/Input/Radio";
import Checkbox from "../Elements/Draggable/Input/Checkbox";
import LongText from "../Elements/Draggable/Input/LongText";
import Select from "../Elements/Draggable/Input/Select";
import Number from "../Elements/Draggable/Input/Number";
import String from "../Elements/Draggable/Input/String";
import Date from "../Elements/Draggable/Input/Date";
import Text from "../Elements/Draggable/Text/Text";
import Area from "../Elements/Draggable/Area/Area";
import "./ElementsSidebar.scss"

const ElementsSidebar = () => {
    const [activeSection, setActiveSection] = useState("area");

    return (
        <div className="elements-sidebar">
            <div className="switch">
                <TypeButton
                    text="Input types"
                    section="input"
                    activeSection={activeSection}
                    setActiveSection={setActiveSection}
                />
                <TypeButton
                    text="Area types"
                    section="area"
                    activeSection={activeSection}
                    setActiveSection={setActiveSection}
                />
                <TypeButton
                    text="Text elements"
                    section="text"
                    activeSection={activeSection}
                    setActiveSection={setActiveSection}
                />
            </div>
            {activeSection === "input" &&
                <div className="elements">
                    <Number/>

                    <String/>

                    <Date/>

                    <Select/>

                    <LongText/>

                    <Checkbox/>

                    <Radio/>

                    <Signature/>
                </div>
            }

            {activeSection === "area" &&
                <div className="elements">
                    <Area id="area-single" name="Single column" amount={1}/>

                    <Area id="area-double" name="Double column" className="double" amount={2}/>

                    <Area id="area-triple" name="2 / 1 / 1" className="triple" amount={3}/>
                </div>
            }

            {activeSection === "text" &&
                <div className="elements">
                    <Text id="text-h1" className="big-header" name="Big header"/>

                    <Text id="text-h2" className="medium-header" name="Medium header"/>

                    <Text id="text-h3" className="small-header" name="Small header"/>

                    <Text id="text-text" name="Text"/>

                    <Text id="text-small" className="small" name="Small text"/>
                </div>
            }
        </div>
    )
}

export default ElementsSidebar;